import React, { useState } from "react";
import Select from "react-select";

export default function SearchSelectField({ options, value, setState }) {
  console.log(value);
  return <Select defaultValue={value} options={options} onChange={setState} />;
}
